<template>
  <div class="modal" :class="{ active: visible }" @click.self="handleClose">
    <div class="modal-body">
      <div style="padding:15px; display:flex; justify-content:space-between; border-bottom:1px solid #e2e8f0;">
        <h3>收银台</h3>
        <button @click="handleClose" style="border:none;background:none;font-size:1.5rem;cursor:pointer">&times;</button>
      </div>
      
      <div class="pay-container" style="position:relative">
        <!-- 左侧支付方式 -->
        <div class="pay-left">
          <div
            class="pay-method-item"
            :class="{ active: payMethod === 'scangun' }"
            @click="activateScanMode"
          >
            <i class="el-icon-camera icon-scan"></i> 扫码枪/被扫
          </div>
          <div
            class="pay-method-item"
            :class="{ active: payMethod === 'cash' }"
            @click="setPayMethod('cash')"
          >
            <i class="el-icon-coin icon-cash"></i> 现金支付
          </div>
          <div
            class="pay-method-item"
            :class="{ active: payMethod === 'wechat' }"
            @click="setPayMethod('wechat')"
          >
            <i class="el-icon-chat-line-round icon-wechat"></i> 微信
          </div>
          <div
            class="pay-method-item"
            :class="{ active: payMethod === 'alipay' }"
            @click="setPayMethod('alipay')"
          >
            <i class="el-icon-wallet icon-alipay"></i> 支付宝
          </div>

          <!-- 抹零功能 -->
          <div class="rounding-area">
            <label class="checkbox-label">
              <input type="checkbox" v-model="isRounding" @change="toggleRounding">
              启用抹零 (去除小数)
            </label>
          </div>
        </div>

        <!-- 右侧金额和数字键盘 -->
        <div class="pay-right">
          <div class="pay-summ-row big">
            <span>应收:</span>
            <span>{{ payableAmount.toFixed(2) }}</span>
          </div>
          <div class="pay-summ-row" style="color:#2563eb">
            <span>实收:</span>
            <span>{{ receivedText }}</span>
          </div>
          <div class="pay-summ-row" style="color:#ef4444">
            <span>找零:</span>
            <span>{{ changeText }}</span>
          </div>
          
          <div class="numpad-grid">
            <button class="num-btn" @click="padInput('7')">7</button>
            <button class="num-btn" @click="padInput('8')">8</button>
            <button class="num-btn" @click="padInput('9')">9</button>
            <button class="num-btn" @click="padInput('4')">4</button>
            <button class="num-btn" @click="padInput('5')">5</button>
            <button class="num-btn" @click="padInput('6')">6</button>
            <button class="num-btn" @click="padInput('1')">1</button>
            <button class="num-btn" @click="padInput('2')">2</button>
            <button class="num-btn" @click="padInput('3')">3</button>
            <button class="num-btn" @click="padInput('C')" style="color:red">C</button>
            <button class="num-btn" @click="padInput('0')">0</button>
            <button class="num-btn confirm" @click="finishPay">结算</button>
          </div>
        </div>

        <!-- 扫码覆盖层 -->
        <div class="scan-layer" :class="{ active: scanMode }">
          <i class="el-icon-camera" style="font-size:150px; opacity:0.1;"></i>
          <div class="scan-line"></div>
          <h2 style="margin:20px 0;">请扫描顾客付款码</h2>
          <div style="font-size:1.5rem; color:#2563eb; font-weight:bold;">¥ {{ payableAmount.toFixed(2) }}</div>
          <div style="margin-top: 30px; width: 80%; max-width: 400px;">
            <el-input
              ref="scanInput"
              v-model="scanCode"
              placeholder="请使用扫码枪扫描顾客付款码"
              size="large"
              @keydown.enter="handleScanInput"
              style="font-size: 1.2rem;"
            >
              <i slot="prefix" class="el-icon-camera"></i>
            </el-input>
          </div>
          <button @click="cancelScanMode" style="margin-top:30px; padding:10px 30px; border:1px solid #ccc; background:white; cursor:pointer; border-radius: 6px;">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckoutModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    totalAmount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      payMethod: 'cash',
      receivedVal: '',
      isRounding: false,
      rawPayable: 0,
      scanMode: false,
      scanCode: ''
    }
  },
  computed: {
    payableAmount() {
      if (this.isRounding) {
        return Math.floor(this.rawPayable)
      }
      return this.rawPayable
    },
    receivedText() {
      return this.receivedVal || '0.00'
    },
    changeText() {
      const rec = parseFloat(this.receivedVal || 0)
      const change = rec - this.payableAmount
      return (rec > 0 && change >= 0) ? change.toFixed(2) : '0.00'
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.rawPayable = this.totalAmount
        this.isRounding = false
        this.receivedVal = ''
        this.payMethod = 'cash'
        this.scanMode = false
        this.scanCode = ''
      }
    }
  },
  methods: {
    setPayMethod(method) {
      this.payMethod = method
      this.receivedVal = ''
      if (method !== 'scangun') {
        this.scanMode = false
      }
    },
    activateScanMode() {
      this.setPayMethod('scangun')
      this.scanMode = true
      this.scanCode = ''
      this.$nextTick(() => {
        if (this.$refs.scanInput && this.$refs.scanInput.$el) {
          const input = this.$refs.scanInput.$el.querySelector('input')
          if (input) {
            input.focus()
          }
        }
      })
    },
    cancelScanMode() {
      this.scanMode = false
      this.setPayMethod('cash')
      this.scanCode = ''
    },
    toggleRounding() {
      // 抹零逻辑已在 computed 中处理
    },
    padInput(n) {
      if (n === 'C') {
        this.receivedVal = ''
      } else {
        this.receivedVal += n
      }
    },
    handleScanInput(e) {
      // 扫码枪扫描后会自动触发 Enter 键
      if (e.key === 'Enter' || e.keyCode === 13) {
        if (this.scanCode && this.scanCode.trim().length > 5) {
          this.$emit('scan-pay', this.scanCode.trim())
          this.scanCode = ''
          this.cancelScanMode()
        } else {
          this.$message.warning('扫码编号无效，请重新扫描')
          this.scanCode = ''
        }
      }
    },
    finishPay() {
      const pay = this.payableAmount
      const rec = parseFloat(this.receivedVal || 0)
      
      if (this.payMethod === 'cash' && rec < pay) {
        this.$message.warning('金额不足')
        return
      }
      
      this.$emit('pay', {
        method: this.payMethod,
        amount: pay,
        received: rec,
        change: this.changeText
      })
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  z-index: 1000;
  align-items: center;
  justify-content: center;
}

.modal.active {
  display: flex;
}

.modal-body {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
  width: 90%;
  max-width: 900px;
}

.pay-container {
  display: flex;
  height: 520px;
}

.pay-left {
  flex: 1;
  background: #f8fafc;
  border-right: 1px solid #cbd5e1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pay-right {
  flex: 1.2;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.pay-method-item {
  padding: 15px;
  background: white;
  border: 2px solid #cbd5e1;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: bold;
  color: #000000;
  font-size: 1rem;
}

.pay-method-item.active {
  border-color: #2563eb;
  color: #2563eb;
  background: #eff6ff;
}

.pay-method-item .icon-scan {
  color: #8b5cf6;
}

.pay-method-item.active .icon-scan {
  color: #2563eb;
}

.pay-method-item .icon-cash {
  color: #f59e0b;
}

.pay-method-item.active .icon-cash {
  color: #2563eb;
}

.pay-method-item .icon-wechat {
  color: #07c160;
}

.pay-method-item.active .icon-wechat {
  color: #2563eb;
}

.pay-method-item .icon-alipay {
  color: #1677ff;
}

.pay-method-item.active .icon-alipay {
  color: #2563eb;
}

.rounding-area {
  margin-top: auto;
  padding-top: 20px;
  border-top: 1px solid #cbd5e1;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-weight: bold;
  color: #475569;
  font-size: 0.95rem;
}

.checkbox-label input {
  width: 20px;
  height: 20px;
}

.pay-summ-row {
  display: flex;
  justify-content: space-between;
  font-size: 1.2rem;
  margin-bottom: 10px;
}

.pay-summ-row.big {
  font-size: 1.8rem;
  font-weight: bold;
  color: #1e293b;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 15px;
  margin-bottom: 15px;
}

.numpad-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  flex: 1;
  margin-top: 10px;
}

.num-btn {
  background: white;
  border: 1px solid #cbd5e1;
  font-size: 1.5rem;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  padding: 15px;
}

.num-btn:active {
  background: #e2e8f0;
}

.num-btn.confirm {
  background: #10b981;
  color: white;
  border: none;
  grid-row: span 2;
}

.scan-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 10;
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.scan-layer.active {
  display: flex;
}

.scan-line {
  width: 200px;
  height: 2px;
  background: #ef4444;
  animation: scanning 2s infinite;
  margin-top: -100px;
}

@keyframes scanning {
  0% { transform: translateY(0); opacity: 0; }
  50% { opacity: 1; }
  100% { transform: translateY(200px); opacity: 0; }
}

</style>

